export enum ActionToastType {
	Success = 'success',
	Error = 'error',
	Warning = 'warning',
	Info = 'info',
}

export interface ActionToastData {
	title?: string;
	message: string;
	messages?: string[];
	requireClose?: boolean;
}

export interface ActionToastResponse {
	actionToast?: ActionToastData & {
		type: ActionToastType;
		title: string;
	};
}
